<template>
  <div class="w-full">
    <label
      v-if="label"
      :for="id"
      class="block text-sm font-bold text-gray-700 mb-2"
    >
      {{ label }}
    </label>
    <div class="relative">
      <slot name="icon" />

      <input
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :value="value"
        :autocomplete="autocomplete"
        :disabled="disabled"
        @input="onInput"
        class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-gray-900 placeholder-gray-400 outline-none transition-all focus:bg-white focus:border-primary-500 focus:ring-2 focus:ring-primary-200 disabled:bg-gray-100 disabled:text-gray-400"
        :class="{
          'pl-10': hasLeadingIcon,
          'border-red-400 focus:border-red-500 focus:ring-red-200':
            error && errorMessage
        }"
      />
    </div>
    <p v-if="error && errorMessage" class="mt-1 text-xs text-red-500">
      {{ errorMessage }}
    </p>
    <p v-else-if="help" class="mt-1 text-xs text-gray-400">
      {{ help }}
    </p>
  </div>
</template>

<script>
export default {
  name: "UiInput",
  props: {
    // Vue 2 v-model (`value` + `input`)
    value: {
      type: [String, Number],
      default: ""
    },
    // Vue 3-style v-model (`modelValue` + `update:modelValue`)
    modelValue: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    hasLeadingIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(event) {
      const newValue = event.target.value;
      // Emit para v-model en Vue 2
      this.$emit("input", newValue);
      // Emit para v-model en patrón modelValue
      this.$emit("update:modelValue", newValue);
    }
  }
};
</script>
